import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevenueCloudFxRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#232323",
			d: "M14.2 12.6h.9v2.2l.2-.3q.8-.7 1.9-.4c1.5.4 1.8 2.6.8 3.7a2 2 0 0 1-1.8.6q-.7-.2-1.1-.8v.8h-1zm2.4 5c1.7-.2 1.5-2.9-.2-2.8s-1.6 3 .2 2.9M11.3 14h.6c1.3.2 1.9 1.3 1.7 2.5h-3.3v.3c.2 1 1.5 1.2 2 .5l.2-.2h1a2 2 0 0 1-1.7 1.3q-2.1.2-2.4-1.9-.2-2.2 2-2.5m-1 1.9h2.3v-.1q-.1-1-1.2-1l-.7.2q-.4.3-.5.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4c74b8",
			d: "M19 12h10v7H19z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M20.2 13H23l.7 1.2h-2.2v.8h1.7v1.1h-1.7v2h-1.3v-1.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M23.5 13H25l.2.3.6 1 .3.5.5.8-.8 1.2-.7 1.3h-1.6l.2-.3 1.4-2.2-.3-.4-1-1.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a5b8db",
			d: "M26.6 13h1.6l-1.3 2-.3.6 1.6 2.5h-1.5l-.7-1-.2-.3.8-1.2-.5-.8-.3-.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#232323",
			d: "M8.6 13h1l-1.3 4-.3 1.4H7l-1-3.5-.2-.6-.6 2.1-.4 1.5-.2.5h-1l-.2-.6-.4-1.5-.7-2.4-.2-1h1v.6l1 3.8 1-3.3.2-1h1l1.2 4.3.8-3.1.2-1z"
		})
	]
});
export default SvgRevenueCloudFxRegularIcon;
